import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Container, HighlightedLink } from '../styles/globalStyles';
import harsha from '../assets/harsha.jpg';
import { FiDownload } from 'react-icons/fi';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { SiLeetcode } from 'react-icons/si';

const Intro = () => {
 

  return (
    <Container>
      <motion.div
        initial={{ opacity: 0, y: 300 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Wrapper>
          <MyImg src={harsha} alt='Harsha vardhan' loading='lazy' />
          <Description>
            <Heading>Harsha Vardhan Kalluru</Heading>
            <Title>Senior Software Engineer</Title>
            <Bio>
              Experienced Full-Stack Developer with 7+ years of hands-on expertise in designing, developing, and scaling web applications across diverse domains including edtech, AI, and fintech. Proficient in modern JavaScript frameworks like React, Next.js, and Node.js, with robust backend experience in Python, Django and MongoDB.
              <br />
              Skilled in building cloud-native solutions using AWS and optimizing system performance at scale.
            </Bio>
            <HighlightedLink
              href="/harsha_vardhan_resume.pdf"
              target='_blank'
            >
              Download Resume <FiDownload />
            </HighlightedLink>
            <IconsWrapper>
              <Icon href='https://github.com/khvr000' target='_blank'>
                <BsGithub />
              </Icon>
              <Icon
                href='https://www.linkedin.com/in/harshavardhan-reddy-a3b5b3b2/'
                target='_blank'
              >
                <BsLinkedin />
              </Icon>
              <Icon href='https://leetcode.com/u/khvr000/' target='_blank'>
                <SiLeetcode />
              </Icon>
            </IconsWrapper>
          </Description>
        </Wrapper>
      </motion.div>
    </Container>
  );
};

export default Intro;

const Wrapper = styled.div`
  padding: 2em 0;
  margin: 2em 0;
  min-height: 50vh;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;
    gap: 6em;
  }
`;

const Description = styled.div`
  flex-grow: 1;
`;

const Heading = styled.h1`
  font-size: 3em;
  line-height: 1.2;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 2.5em;
  }
`;

const Title = styled.p`
  font-size: 1.2em;
  font-weight: 400;
`;

const Bio = styled.p`
  color: var(--other-para-color);
  font-size: 0.9em;
  margin-bottom: 1em;
`;

const MyImg = styled.img`
  display: block;
  width: 50%;
  max-width: 190px;
  border-radius: 50%; /* Ensures a circular shape */
  object-fit: cover; /* Ensures the image fills the circle without distortion */

  @media (max-width: 768px) {
    margin-bottom: 1.5em;
    max-width: 80px;
  }
`;

const IconsWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 1em;
`;

const Icon = styled.a`
  color: var(--para-color);
  font-size: 1.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4em;

  :hover {
    color: var(--accent-blue);
  }
`;
